import { render, staticRenderFns } from "./FiltrosActions.vue?vue&type=template&id=5b96779e&scoped=true&"
import script from "./FiltrosActions.vue?vue&type=script&lang=js&"
export * from "./FiltrosActions.vue?vue&type=script&lang=js&"
import style0 from "./FiltrosActions.vue?vue&type=style&index=0&id=5b96779e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b96779e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
